// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nt-0";
export var assigneeDetails = "_nt-1";
export var assigneeInfo = "_nt-2";
export var dropdownContainer = "_nt-4";
export var dropdownImage = "_nt-5";
export var editAssigneeInfo = "_nt-3";
export var editAssigneeModalContainer = "_nt-6";
export var hidden = "_nt-8";
export var input = "_nt-7";